/* global __webpack_public_path__ */
__webpack_public_path__ = "/";
